<template>
  <div class="view-plans py-5">
    <div class="container py-5">
      <h1 class="mb-4">Planos</h1>

      <div class="row">
        <div
          v-for="(product, i) in $user.cof.products"
          class="col-lg col-md-6 pb-4"
          :key="i"
        >
          <div class="card text-center">
            <div
              v-if="product.interval === 'year'"
              class="card-header bg-warning text-light font-weight-bold"
            >
              MAIS VENDIDO!
            </div>
            <div class="card-body">
              <strong>{{ product.name }}</strong>
              <h1><small>R$</small> {{ formatMoney(product.price_card) }}</h1>
              <p>
                <small>a cada {{ interval(product) }}</small>
              </p>
              <!-- <span class="badge">R$ 40,00 DE DESCONTO</span> -->
              <hr />
              <p>Acesso às aulas ao vivo</p>
              <p>Acesso a textos, áudios e vídeos</p>
              <p>Áudios disponíveis para download</p>
              <button
                class="btn btn-success px-5 font-weight-bold"
                @click="subscribe(product)"
              >
                Assinar
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex mt-5 mb-4">
        <h2 class="mb-0">Outros produtos</h2>
        <div class="flex-fill"></div>
        <router-link :to="{ name: 'catalog' }" class="font-weight-bold"
          >Ver todos</router-link
        >
      </div>

      <action-dispatcher action="courses/getFeatured">
        <div class="row">
          <div
            v-for="(course, index) in featured"
            class="col-lg-3 col-md-6 my-2 d-flex flex-column"
            :key="index"
          >
            <course-card class="flex-fill" :course="course" />
          </div>
        </div>
      </action-dispatcher>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CourseCard from "@/components/courses/CourseCard";
import { formatMoney } from "@/functions/helpers.js";

export default {
  components: { CourseCard },
  computed: {
    ...mapState("courses", ["featured"])
  },
  methods: {
    formatMoney,
    interval(product) {
      const intTxt = {
        day: { s: "dia", p: "dias" },
        week: { s: "semana", p: "semanas" },
        month: { s: "mês", p: "meses" },
        year: { s: "ano", p: "anos" }
      }[product.interval];

      if (product.subscription_period > 1) {
        return `${product.subscription_period} ${intTxt.p}`;
      }
      return intTxt.s;
    },
    subscribe(product) {
      const checkoutUrl = product.purchase_url
        ? product.purchase_url
        : `https://pay.seminariodefilosofia.org/${product.prod_id}`;
      window.open(checkoutUrl);
    }
  }
};
</script>

<style lang="scss" scoped>
.view-plans {
  h1 {
    small {
      font-size: 16px;
    }
  }

  p {
    font-size: 14px;
    line-height: 24px;
    color: #979797;
  }

  small {
    color: #979797;
  }

  .badge {
    background: rgba(60, 193, 59, 0.1);
    font-weight: bold;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #3cc13b;
    padding: 5px 8px;
    border-radius: 14px;
  }

  hr {
    width: 50%;
  }

  .card {
    overflow: hidden;

    .card-header {
      padding: 4px;
      font-size: 14px;
      line-height: 21px;
      border: none;
    }

    h1 {
      margin-bottom: 0;
      color: #272d32;
    }
  }
}
</style>
